import {
  Company_User_Status,
  OrderType,
  PlatformCompanyUserListOrderFields,
  PlatformCompanyUserListOrderInput,
  useCompanyUserInvitesQuery,
  useCompanyUsersQuery,
} from "@generated/graphql";
import TableConstructor from "layout/TableConstructor";
import { useMemo } from "react";
import columnConfig from "./tableConfig/columnConfig";
import { TeamMember, TeamMembersFilter } from "./tableConfig/types";

type TeamMembersTableProps = {
  filter: TeamMembersFilter;
};

const TeamMembersTable = ({ filter }: TeamMembersTableProps) => {
  const order: PlatformCompanyUserListOrderInput = {
    field: PlatformCompanyUserListOrderFields.CreatedAt,
    order: OrderType.Desc,
  };
  const { data, loading, refetch } = useCompanyUsersQuery({
    variables: {
      page: 0,
      limit: 50,
      filter,
      order,
    },
  });
  const { data: invitesData, loading: isInvitesLoading } = useCompanyUserInvitesQuery();
  const inviteTokens = useMemo(
    () => new Map(invitesData?.companyUserInvites?.map((invite) => [invite.email, invite.token])),
    [invitesData]
  );
  const columnsConfig = useMemo(
    () => columnConfig({ inviteTokens, isInvitesLoading }),
    [inviteTokens, isInvitesLoading]
  );

  return (
    <TableConstructor<TeamMember, TeamMembersFilter, PlatformCompanyUserListOrderFields>
      data={data?.companyUsers.data || []}
      totalCount={data?.companyUsers.totalCount}
      loading={loading}
      columnsConfig={columnsConfig}
      filtersConfig={[]}
      emptyPlaceholderText='Пока нет сотрудников'
      refetch={refetch}
      storageName='companyUsers'
      settingsModalTitle='Список сотрудников'
      defaultOrder={order}
      permanentFilter={filter}
      getRowOpacity={(employee) => (employee.status === Company_User_Status.Deactivated ? 0.6 : undefined)}
      defaultVisibleColumnList={["employee", "role", "status", "createdAt", "action"]}
    />
  );
};

export default TeamMembersTable;
